import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { mainHeadingId } from 'App'

export default function useScrollAndFocusOnPathChange () {
  const { pathname, hash } = useLocation()
  const lastPath = useRef<string>('')
  const initialLoad = useRef<boolean>(true)

  useEffect(() => {
    if (!initialLoad.current && lastPath.current !== pathname && !hash) {
      window.scrollTo(0, 0)
      document.getElementById(mainHeadingId)?.focus()
      lastPath.current = pathname
    }
    initialLoad.current = false
  }, [pathname, hash])

  return null
}
